export default __webpack_public_path__ + "static/media/img-0193-ireland-premium-face.cf4c1192.png";